import React from "react";
import { X } from "lucide-react";
import { PinnedMessage } from "../../types/chat";
import { PinnedMessageItem } from "./PinnedMessageItem";
import styles from "./PinnedMessages.module.scss";

interface PinnedMessageListProps {
  messages: PinnedMessage[];
  onCollapse: () => void;
  onUnpin: (messageId: string) => void;
  onScrollTo: (messageId: string) => void;
}

export const PinnedMessageList: React.FC<PinnedMessageListProps> = ({ messages, onCollapse, onUnpin, onScrollTo }) => {
  return (
    <div>
      <div className={styles.listHeader}>
        <div className={styles.listTitle}>{messages.length} tin nhắn đã ghim</div>
        <X className={styles.closeButton} size={20} onClick={onCollapse} />
      </div>
      <div className={styles.list}>
        {messages.map((message) => (
          <PinnedMessageItem
            key={message.MessageId}
            message={message}
            onUnpin={onUnpin}
            onScrollTo={onScrollTo}
            onCollapse={onCollapse}
          />
        ))}
      </div>
    </div>
  );
};
